"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.salesPersonFields = void 0;
exports.salesPersonFields = `
  fullName
  id
  username
`;
//# sourceMappingURL=sales-person.js.map